import { cva } from "class-variance-authority";

export const DIALOG_PLACEMENTS = ["viewport", "contained"] as const;

export type DialogPlacement = (typeof DIALOG_PLACEMENTS)[number];

export const DIALOG_SIZES = ["default", "wide"] as const;

export type DialogSize = (typeof DIALOG_SIZES)[number];

export const DIALOG_OVERLAYS = ["dim", "frosted"] as const;

export type DialogOverlayVariant = (typeof DIALOG_OVERLAYS)[number];

export const dialogOverlayVariants = cva(
  "inset-0 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  {
    variants: {
      placement: {
        viewport: "fixed",
        contained: "absolute",
      } satisfies Record<DialogPlacement, string>,
      overlay: {
        dim: "bg-black/50",
        frosted: "bg-background/80 backdrop-blur-sm",
      } satisfies Record<DialogOverlayVariant, string>,
    },
    defaultVariants: { placement: "viewport", overlay: "dim" },
  }
);

export const dialogContentVariants = cva(
  "top-[50%] left-[50%] flex w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] flex-col overflow-x-hidden overflow-y-auto rounded-lg border bg-background duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
  {
    variants: {
      placement: {
        viewport: "fixed max-h-[90dvh]",
        contained: "absolute max-h-[calc(100%-2rem)]",
      } satisfies Record<DialogPlacement, string>,
      size: {
        default: "sm:max-w-lg",
        wide: "sm:max-w-4xl",
      } satisfies Record<DialogSize, string>,
      overlay: {
        dim: "shadow-lg",
        frosted: "",
      } satisfies Record<DialogOverlayVariant, string>,
      divided: {
        true: "gap-0",
        false: "gap-4 p-6",
      },
    },
    defaultVariants: { placement: "viewport", size: "default", overlay: "dim", divided: false },
  }
);

export const DIVIDED_REGION_CLASS = "px-6 py-4 [&:not(:first-child)]:border-t";
